var exports = {
  "Y": "anchor__HkwMQD",
};

module.exports = exports;
